import db from './index.js'

export async function getAppConfig() {
    let config = await db.appConfig.get(1)
    if (!config) {
        config = {
            id: 1,
            lastSyncedAt: null,
        }
        await db.appConfig.put(config)
    }
    return config
}

export async function updateAppConfig(updates) {
    const config = await getAppConfig()
    const newConfig = { ...config, ...updates }
    return await db.appConfig.put(newConfig)
}

export async function updateLastSyncedAt(timestamp) {
    return await updateAppConfig({ lastSyncedAt: timestamp })
}
